/**
 * 한국보건의료정보원(의정원) 중계전문기관 시스템 점검 안내
 *
 * 점검 시간 동안 의정원 중계를 거치는 기능(로그인·회원가입·전송요구·기관연결·탈퇴 등)이
 * 실패하거나 최대 5분(미들서버 타임아웃)까지 멈추므로, 의정원 API 를 부르는 화면은
 * 기능을 가리지 않고 전부 막고 안내문을 보여준다.
 * 시간창이 지나면 저절로 꺼진다. 점검이 끝나면 이 파일과 사용처를 함께 걷어낸다.
 */
export const MHW_MAINTENANCE = {
  start: new Date("2026-10-15T19:00:00+09:00"),
  end: new Date("2026-10-16T05:00:00+09:00"),
  periodLabel: "10월 15일(목) 19:00 ~ 10월 16일(금) 05:00",
} as const;

export const isMhwMaintenanceActive = (now: Date = new Date()): boolean =>
  now >= MHW_MAINTENANCE.start && now < MHW_MAINTENANCE.end;
